import { HeroCardStoryblok } from "@/generated/sb/sb-types";
import { Link } from "@/i18n/routing";
import { getLink } from "@frend-digital/storyblok";
import { ReactNode } from "react";
import styles from "./index.module.css";

const isValidLink = (link: HeroCardStoryblok["link"]) => {
  const newLink = link || {};
  return (
    link?.cached_url ||
    ("url" in newLink && newLink?.url) ||
    ("id" in newLink && newLink.id)
  );
};

export const CompWrapper = ({
  children,
  link,
}: {
  children: ReactNode;
  link: HeroCardStoryblok["link"];
}) => {
  if (isValidLink(link)) {
    const href = getLink(link)?.href;

    if (href) {
      return (
        <Link href={href} className={styles.contentContainer}>
          {children}
        </Link>
      );
    }
  }
  return <div className={styles.contentContainer}>{children}</div>;
};
